import createTableStore from "ds/components/Table/store/useTableStore";

import { MODULES_COLUMN_CONFIG, MODULES_COLUMNS_STORAGE_KEY } from "./constants";

const useModulesTableStore = createTableStore({
  storageKey: MODULES_COLUMNS_STORAGE_KEY,
  config: MODULES_COLUMN_CONFIG,
});

export default useModulesTableStore;
